
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/edit",
      function () {
        return require("private-next-pages/profile/edit/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/edit"])
      });
    }
  